import React, { useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Table, Modal } from "react-bootstrap";
import {
  CurrencyActions,
  deleteCurrencyAsync,
  updateCurrencyAsync,
} from "../../redux";
import BasicPagination from "../../../pagination/BasicPagination";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";

import { CircularProgress } from "@material-ui/core";

const CurrencyTable = ({ onEditClick }) => {
  const { isLoading, currencyList, skip, limit } = useSelector(
    (state) => state.currencyManagement,
    shallowEqual
  );

  const [DeleteModal, setDeleteModal] = useState(false);
  const deleteClose = () => setDeleteModal(false);
  const deleteShow = () => setDeleteModal(true);
  const dispatch = useDispatch();
  const [selectedCurrencyName, setselectedCurrencyName] = useState({});
  //on page change
  const onPageChange = (currentBatch) => {
    let count = currentBatch ? currentBatch - 1 : skip;
    dispatch(CurrencyActions.setCurrencyBatchNumber(count));
  };
  //show delete model and save delete email id
  const onDeleteClick = (CurrencyLists) => {
    setselectedCurrencyName(CurrencyLists);
    deleteShow();
  };
  //call delete email api and close delete model
  const onDeactiveClick = () => {
    dispatch(deleteCurrencyAsync(selectedCurrencyName._id));
    setselectedCurrencyName({});
    deleteClose();
  };

  //change status of virtual token and call update virtual token api
  const handleToggle = (isActive, currencyId) => {
    const values = {
      _id: currencyId,
      isActive: isActive === true ? false : true,
    };
    dispatch(updateCurrencyAsync(values));
  };

  return (
    <div className="px-6 pt-0 dash_wt_bx pb-0 ovflhddn loader-display-position">
      <div className="tblmrgn mt-0">
        <div className="mt-5">
          <div>
            <Table
              hover
              responsive
              className="mb-0 default_table with_hoverbtn mrpdng_tbl"
            >
              <thead>
                <tr>
                  <th>Sr No.</th>
                  <th>Title</th>
                  <th>Short Name</th>
                  <th>Currency Symbol</th>
                  <th>Buyer value</th>
                  <th>Sale value</th>
                  <th>Status</th>
                  <th width="120px">Action</th>
                </tr>
              </thead>
              <tbody>
                {currencyList.data && currencyList.data.currencyList.length ? (
                  currencyList.data.currencyList.map((CurrencyLists, index) => (
                    <tr key={index}>
                      <td>
                        <span className="f-w-500">
                          {skip * limit + (index + 1)}
                        </span>
                      </td>
                      <td>
                        <span className="f-w-500">{CurrencyLists.title}</span>
                      </td>
                      <td>{CurrencyLists.shortName}</td>
                      <td>{CurrencyLists.currencySymbol}</td>
                      <td>{CurrencyLists.buyer_value}</td>
                      <td>{CurrencyLists.sale_value}</td>

                      <td>
                        {console.log("CurrencyLists",CurrencyLists.shortName)}
                        {console.log("CurrencyLists.shortName !== USD",CurrencyLists.shortName !== "USD")}
                        {CurrencyLists.shortName !== "USD" ? (
                          <button
                            value={CurrencyLists && CurrencyLists.isActive}
                            onClick={() =>
                              handleToggle(
                                CurrencyLists.isActive,
                                CurrencyLists._id
                              )
                            }
                            className={`pmnt_btn ${
                              CurrencyLists && CurrencyLists.isActive
                                ? "label label-lg label-light-success label-inline"
                                : "label label-lg label-light-danger label-inline"
                            }`}
                          >
                            {CurrencyLists && CurrencyLists.isActive
                              ? "ACTIVE"
                              : "INACTIVE"}
                          </button>
                        ) : (
                          "-"
                        )}
                      </td>

                      <td>
                        <a
                          title="Edit"
                          className="btn btn-icon btn-light btn-hover-primary btn-sm mr-3"
                          onClick={() => onEditClick(CurrencyLists)}
                        >
                          <span className="svg-icon svg-icon-md svg-icon-primary">
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/Communication/Write.svg"
                              )}
                            />
                          </span>
                        </a>
                        {/* <a
                          title="Delete"
                          className="btn btn-icon btn-light btn-hover-danger btn-sm"
                          onClick={() => onDeleteClick(CurrencyLists)}
                        >
                          <span className="svg-icon svg-icon-md svg-icon-danger">
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/General/Trash.svg"
                              )}
                            />
                          </span>
                        </a> */}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={5} className="text-center">
                      No Record Found
                    </td>
                  </tr>
                )}
                {isLoading && (
                  <tr>
                    <td colSpan={5} className="text-center">
                      <div className="basic-verification-loader text-center">
                        <CircularProgress />
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>

          <div className="row d-flex align-items-center mr-5 ml-5 mt-4 btm-pagination">
            <div className="col-md-4 mb-5 fn_s_16 f-w-400 text-left">
              Displaying {skip * limit + 1} - {skip * limit + limit} of{" "}
              {currencyList?.data?.count} Records
            </div>
            <div className="col-md-8 text-left mb-5 aspgntn">
              <BasicPagination
                totalRecords={currencyList?.data?.count}
                limit={limit}
                batch={skip + 1}
                onBatchChange={onPageChange}
              />
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={DeleteModal}
        onHide={deleteClose}
        centered
        className="def_modal delete_modal"
      >
        <Modal.Header>
          <Modal.Title className="fn_s_18 color_blk f-w-700">Alert</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="form def_form frmwtpddng">
            <p className="fn_s_18 f-w-400 text-center mb-10">
              Are you sure want to delete?
            </p>
            <div className="form-group d-flex flex-wrap justify-content-center align-items-center mb-0">
              <div className="form-group mr-5 mb-1 mt-2">
                <button
                  className="btn_new btn-sm"
                  type="button"
                  onClick={deleteClose}
                >
                  Close
                </button>
              </div>
              <div className="form-group mr-5 mb-1 mt-2">
                <button
                  className="btn_new btn-sm"
                  type="button"
                  onClick={onDeactiveClick}
                >
                  Yes, Delete it
                </button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default CurrencyTable;
